import { hasWindow } from "@omni/utils/dom.utils";

import {
    PureAemComponent,
    registerComponent
} from "@/components/pureAemComponent";
import * as ScrollPositionService from "@/services/scrollPosition.service";

const PAGE_LINK_ANCHOR_ELEMENT_SELECTOR = "a.pl__listitem__wrapper--link";

class PageLink extends PureAemComponent {
    private readonly _anchorElement: HTMLAnchorElement | null;

    constructor(element: HTMLElement) {
        super(element);
        this._anchorElement = this._getAnchorElement();

        this._registerEventHandlers();
    }

    private _registerEventHandlers() {
        this._anchorElement?.addEventListener("click", () =>
            ScrollPositionService.pushPosition(
                0,
                this._anchorElement?.href ?? window.location.href
            )
        );
    }

    private _getAnchorElement() {
        const element = this.element.querySelector(
            PAGE_LINK_ANCHOR_ELEMENT_SELECTOR
        );

        return element instanceof HTMLAnchorElement ? element : null;
    }
}

const InitPageLink = () => {
    hasWindow() && registerComponent(".pl-component", PageLink);
};

export { InitPageLink };
